import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBatchColumnStore = defineStore(
  'batch-columns',
  () => {
    const initialized = ref(false)
    const visibleColumns = ref<string[]>([])
    const columnOrdering = ref<string[]>([])

    function initialize(allColumnSelectors: string[], coreColumnSelectors: string[]) {
      if (initialized.value && visibleColumns.value.length > 0) {
        // Prune stale selectors that no longer exist
        visibleColumns.value = visibleColumns.value.filter((c) => allColumnSelectors.includes(c))
        columnOrdering.value = columnOrdering.value.filter((c) => allColumnSelectors.includes(c))
        return
      }

      visibleColumns.value = [...coreColumnSelectors]
      columnOrdering.value = [...allColumnSelectors]
      initialized.value = true
    }

    function setVisibleColumns(selectors: string[]) {
      visibleColumns.value = selectors
    }

    function setColumnOrdering(selectors: string[]) {
      columnOrdering.value = selectors
    }

    function toggleColumn(selector: string) {
      const idx = visibleColumns.value.indexOf(selector)
      if (idx === -1) {
        visibleColumns.value = [...visibleColumns.value, selector]
      } else {
        visibleColumns.value = visibleColumns.value.filter((_, i) => i !== idx)
      }
    }

    function resetColumns(allColumnSelectors: string[], coreColumnSelectors: string[]) {
      visibleColumns.value = [...coreColumnSelectors]
      columnOrdering.value = [...allColumnSelectors]
    }

    return {
      initialized,
      visibleColumns,
      columnOrdering,
      initialize,
      setVisibleColumns,
      setColumnOrdering,
      toggleColumn,
      resetColumns,
    }
  },
  {
    persist: true,
  },
)
